// @ts-nocheck
import { reducers } from "@insite/client-framework/Store/Reducers";
import getExtensionPropsFromCombinedReducer from "@toolkit/Framework/Common/Utilities/redux/getExtensionPropsFromCombinedReducer";
import { combineReducers } from "redux";
import ProductDetailsReducer from "@store/Extensions/Store/Pages/ProductDetails/ProductDetailsReducer";
import CheckoutReviewAndSubmitReducer from "@store/Extensions/Store/Pages/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitReducer";

const pagesReducer = combineReducers({
    ...getExtensionPropsFromCombinedReducer(reducers.pages),
    productDetails: ProductDetailsReducer,
    checkoutReviewAndSubmit: CheckoutReviewAndSubmitReducer,
});

export default pagesReducer;
